export const GALLERY_HIDE_POST = 'GALLERY_HIDE_POST';
export const GALLERY_SET_FILTERS = 'GALLERY_SET_FILTERS';
export const PORTFOLIO_QUERY_COMPLETE = 'PORTFOLIO_QUERY_COMPLETE';
export const FETCH_GALLERY_POSTS_START = 'FETCH_GALLERY_POSTS_START';
export const FETCH_GALLERY_POSTS_SUCCESS = 'FETCH_GALLERY_POSTS_SUCCESS';
export const FETCH_GALLERY_POSTS_FAILURE = 'FETCH_GALLERY_POSTS_FAILURE';
